export default function FileUploadIcon() {
  return (
    <svg
      width="92"
      height="66"
      viewBox="0 0 92 66"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="46.7315" cy="32" r="32" fill="#EAECF0" />
      <circle cx="13.1316" cy="7.99981" r="3.2" fill="#F2F4F7" />
      <circle cx="81.9313" cy="50.4" r="2.4" fill="#F2F4F7" />
      <circle cx="12.7324" cy="55.2002" r="4" fill="#F2F4F7" />
      <circle cx="86.7319" cy="15.2002" r="4" fill="#F2F4F7" />
      <circle cx="79.1315" cy="4.39961" r="2.8" fill="#F2F4F7" />
      <g filter="url(#filter0_dd_869_21871)">
        <path
          d="M25.1632 49.6848L46.1438 39.9015C47.1972 39.4103 47.6529 38.1581 47.1617 37.1048L34.7715 10.5338L26.3813 7.48004L9.21543 15.4846C8.16204 15.9758 7.7063 17.228 8.1975 18.2813L22.3665 48.6669C22.8577 49.7203 24.1099 50.176 25.1632 49.6848Z"
          fill="url(#paint0_linear_869_21871)"
        />
        <path
          d="M26.3809 7.48047L34.771 10.5342L29.0491 13.2024L26.3809 7.48047Z"
          fill="#D0D5DD"
        />
      </g>
      <g filter="url(#filter1_dd_869_21871)">
        <path
          d="M35.1924 42.5356H58.3418C59.5041 42.5356 60.4463 41.5934 60.4463 40.4311V11.1133L54.1328 4.7998H35.1924C34.0301 4.7998 33.0879 5.74202 33.0879 6.9043V40.4311C33.0879 41.5934 34.0301 42.5356 35.1924 42.5356Z"
          fill="url(#paint1_linear_869_21871)"
        />
        <path
          d="M54.1323 4.7998L60.4458 11.1133H54.1323V4.7998Z"
          fill="#D0D5DD"
        />
      </g>
      <g filter="url(#filter2_dd_869_21871)">
        <path
          d="M47.0962 39.8894L68.0767 49.6728C69.1301 50.164 70.3822 49.7083 70.8735 48.6549L83.2637 22.0839L80.2099 13.6938L63.044 5.6892C61.9907 5.198 60.7385 5.65374 60.2473 6.70713L46.0783 37.0927C45.5871 38.1461 46.0428 39.3982 47.0962 39.8894Z"
          fill="url(#paint2_linear_869_21871)"
        />
        <path
          d="M80.2109 13.6943L83.2647 22.0845L77.5427 19.4163L80.2109 13.6943Z"
          fill="#D0D5DD"
        />
      </g>
      <foreignObject x="32.3312" y="32.0002" width="28.7999" height="28.8004">
        <svg
          xmlns="http://www.w3.org/1999/xhtml"
          style={{
            backdropFilter: "blur(1.6px)",
            clipPath: "url(#bgblur_0_869_21871_clip_path)",
            height: "100%",
            width: "100%",
          }}
        ></svg>
      </foreignObject>
      <g data-figma-bg-blur-radius="3.2">
        <rect
          x="35.5312"
          y="35.2002"
          width="22.4"
          height="22.4"
          rx="11.2"
          fill="#94A3B8"
        />
        <g clip-path="url(#clip1_869_21871)">
          <path
            d="M48.5982 48.2667L46.7315 46.4M46.7315 46.4L44.8649 48.2667M46.7315 46.4V50.6M50.6469 49.382C51.102 49.1339 51.4616 48.7412 51.6688 48.2661C51.876 47.7909 51.9191 47.2602 51.7912 46.7578C51.6634 46.2554 51.3718 45.8099 50.9626 45.4916C50.5535 45.1733 50.0499 45.0004 49.5315 45H48.9435C48.8023 44.4537 48.539 43.9464 48.1735 43.5165C47.808 43.0865 47.3498 42.745 46.8333 42.5176C46.3168 42.2903 45.7555 42.1829 45.1916 42.2037C44.6276 42.2245 44.0758 42.3728 43.5774 42.6376C43.0791 42.9024 42.6472 43.2767 42.3143 43.7324C41.9815 44.1881 41.7562 44.7133 41.6556 45.2685C41.5549 45.8238 41.5814 46.3947 41.7332 46.9382C41.8849 47.4818 42.1578 47.9838 42.5315 48.4067"
            stroke="white"
            stroke-width="0.933334"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </g>
      </g>
      <defs>
        <filter
          id="filter0_dd_869_21871"
          x="-0.691896"
          y="4.81152"
          width="56.7432"
          height="61.7627"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feMorphology
            radius="1.6"
            operator="erode"
            in="SourceAlpha"
            result="effect1_dropShadow_869_21871"
          />
          <feOffset dy="3.2" />
          <feGaussianBlur stdDeviation="1.6" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.03 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_869_21871"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feMorphology
            radius="1.6"
            operator="erode"
            in="SourceAlpha"
            result="effect2_dropShadow_869_21871"
          />
          <feOffset dy="8" />
          <feGaussianBlur stdDeviation="4.8" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.08 0"
          />
          <feBlend
            mode="normal"
            in2="effect1_dropShadow_869_21871"
            result="effect2_dropShadow_869_21871"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect2_dropShadow_869_21871"
            result="shape"
          />
        </filter>
        <filter
          id="filter1_dd_869_21871"
          x="25.0879"
          y="4.7998"
          width="43.3584"
          height="53.7354"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feMorphology
            radius="1.6"
            operator="erode"
            in="SourceAlpha"
            result="effect1_dropShadow_869_21871"
          />
          <feOffset dy="3.2" />
          <feGaussianBlur stdDeviation="1.6" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.03 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_869_21871"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feMorphology
            radius="1.6"
            operator="erode"
            in="SourceAlpha"
            result="effect2_dropShadow_869_21871"
          />
          <feOffset dy="8" />
          <feGaussianBlur stdDeviation="4.8" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.08 0"
          />
          <feBlend
            mode="normal"
            in2="effect1_dropShadow_869_21871"
            result="effect2_dropShadow_869_21871"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect2_dropShadow_869_21871"
            result="shape"
          />
        </filter>
        <filter
          id="filter2_dd_869_21871"
          x="37.189"
          y="4.7998"
          width="56.7427"
          height="61.7627"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feMorphology
            radius="1.6"
            operator="erode"
            in="SourceAlpha"
            result="effect1_dropShadow_869_21871"
          />
          <feOffset dy="3.2" />
          <feGaussianBlur stdDeviation="1.6" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.03 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_869_21871"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feMorphology
            radius="1.6"
            operator="erode"
            in="SourceAlpha"
            result="effect2_dropShadow_869_21871"
          />
          <feOffset dy="8" />
          <feGaussianBlur stdDeviation="4.8" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.08 0"
          />
          <feBlend
            mode="normal"
            in2="effect1_dropShadow_869_21871"
            result="effect2_dropShadow_869_21871"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect2_dropShadow_869_21871"
            result="shape"
          />
        </filter>
        <clipPath
          id="bgblur_0_869_21871_clip_path"
          transform="translate(-32.3312 -32.0002)"
        >
          <rect x="35.5312" y="35.2002" width="22.4" height="22.4" rx="11.2" />
        </clipPath>
        <linearGradient
          id="paint0_linear_869_21871"
          x1="23.9306"
          y1="49.7668"
          x2="7.21083"
          y2="19.6029"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#E4E7EC" />
          <stop offset="1" stop-color="#F9FAFB" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_869_21871"
          x1="34.0406"
          y1="42.0889"
          x2="31.6351"
          y2="7.68506"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#E4E7EC" />
          <stop offset="1" stop-color="#F9FAFB" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_869_21871"
          x1="46.2412"
          y1="38.9978"
          x2="58.6007"
          y2="6.80077"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#E4E7EC" />
          <stop offset="1" stop-color="#F9FAFB" />
        </linearGradient>
        <clipPath id="clip1_869_21871">
          <rect
            width="11.2"
            height="11.2"
            fill="white"
            transform="translate(41.1313 40.7998)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}
